/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base component.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const EarningsSummary = dynamic(() => import('./EarningsSummary').then(mod => mod.EarningsSummary));

export const EarningsSummaryConfig = {
  emptyLabel: 'Earnings Summary',
  isEmpty: () => true,
  resourceType: `mi-aem-account/components/content/earningssummary`,
};

// export * from './EarningsSummary.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EarningsSummaryEditable = (props: any) => {
  return (
    <EditableComponent config={EarningsSummaryConfig} {...props}>
      <EarningsSummary {...props} />
    </EditableComponent>
  );
};
